/**
 * /app/{tenantSlug}/loans — old Loans & Advances list. Navigation rebuild
 * (wave 3, 28 Oct 2026): the employee's own loans are now Me → Pay → Loans
 * (/me/loans) and HR's company-wide list is Manage → Payroll → Loans &
 * Advances (/loans/manage). This route only redirects, by role
 * (lib/me-redirects.ts loansHomeFor), so old links and bookmarks keep
 * working. The loan pages under /loans/* are unchanged.
 *
 * The redirect needs the viewer's role, which lives in the auth context
 * (not the router context), so it happens on render; the auth gate has
 * already loaded /me by then.
 *
 * LoanTable and formatDuePeriod moved to components/loans/loan-table.tsx;
 * they are re-exported here for the sibling routes that import them.
 */

import { createFileRoute, Navigate, useParams } from "@tanstack/react-router";
import { useAuth } from "@/lib/auth";
import { loansHomeFor } from "@/lib/me-redirects";

export { formatDuePeriod, LoanTable } from "@/components/loans/loan-table";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/loans/")({
  component: LoansRedirect,
});

function LoansRedirect() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  const { user } = useAuth();
  return <Navigate to={loansHomeFor(user?.role)} params={{ tenantSlug }} replace />;
}
